import Constant from '@/const';
import axios from 'axios';

const getGroup = async () => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat('/master/drugsgroup'),
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default getGroup;
